<template>
  <div v-if="headlineTitle" class="container">
    <div class="headline__wrapper">
      <div class="headline">
        <div class="columns">
          <div class="column">
            <div v-if="headlineTitle" class="headline__title" :class="{ 'white-text': isWhiteTitle }">
              <span>{{ headlineTitle }}</span>
              <span class="headline__regione" v-if="regions.length && selectedRegionItem">
              <span v-if="selectedRegionItem">:</span>
              {{ selectedRegionItem }}
            </span>
            </div>
            <span
             class="headline__slash"
             v-if="(headlineTitle && headlineMoreTitle && showMore) || regions.length"
            >
            /
          </span>

            <transition name="slide-fade">
              <ModuleRegionsList
               v-if="regions.length"
               :regions-item="regions"
               @selectedRegion="selectedRegion"
              />
            </transition>

            <div class="headline__more-title" v-if="headlineMoreTitle && showMore">
              <app-link
               app-link
               :to="showMore.url"
               :path-type="showMore.type"
               :routing-data="showMore.routing_data"
               class="headline__more"
              >
                {{ headlineMoreTitle }}
              </app-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { onMounted, ref } from 'vue'
import ModuleRegionsList from '@/components/regions/ModuleRegionsList.vue'
import AppLink from '@/components/layout/AppLink.vue'

const selectedRegionItem = ref('')

const emit = defineEmits(['changeRegion'])
const selectedRegion = (item) => {
  selectedRegionItem.value = item.title
  emit('changeRegion', item)
}
const props = defineProps({
  headlineTitle: {
    type: String,
    default: ''
  },
  headlineMoreTitle: {
    type: String,
    default: ''
  },
  headlineMoreUrl: {
    type: String,
    default: ''
  },
  showMore: {
    type: Object,
    default: () => ({})
  },
  isWhiteTitle: {
    type: Boolean,
    default: false
  },
  regions: {
    type: Array,
    default: () => []
  }
})

onMounted(() => {
  // selectedRegionItem.value = 'props.regions?.[0]?.title'
  if (props.regions.length) {
    const currentRegion = props.regions.find((o) => o.title === props.regions?.[0]?.title)
    emit('changeRegion', currentRegion)
  }
})
</script>

<style lang="scss">
@import '@/assets/scss/components/elements/headline.scss';
</style>
